import { EuiHealth } from "@elastic/eui";
import React from "react";

export const eduOptions = [
  {
    value: "Primary Education",
    inputDisplay: (
      <EuiHealth color="subdued" style={{ lineHeight: "inherit" }}>
        Primary Education
      </EuiHealth>
    ),
  },
  {
    value: "Secondary Education",
    inputDisplay: (
      <EuiHealth color="warning" style={{ lineHeight: "inherit" }}>
        Secondary Education
      </EuiHealth>
    ),
  },
  {
    value: "Tertiary Education",
    inputDisplay: (
      <EuiHealth color="danger" style={{ lineHeight: "inherit" }}>
        Tertiary Education
      </EuiHealth>
    ),
  },
];

export const genderOptions = [
  {
    value: "female",
    inputDisplay: (
      <EuiHealth color="subdued" style={{ lineHeight: "inherit" }}>
        Female
      </EuiHealth>
    ),
  },
  {
    value: "male",
    inputDisplay: (
      <EuiHealth color="warning" style={{ lineHeight: "inherit" }}>
        Male
      </EuiHealth>
    ),
  },
];

export const innovStateOptions = [
  {
    value: "Functioning",
    inputDisplay: (
      <EuiHealth color="subdued" style={{ lineHeight: "inherit" }}>
        Functioning
      </EuiHealth>
    ),
  },
  {
    value: "Not Functioning",
    inputDisplay: (
      <EuiHealth color="warning" style={{ lineHeight: "inherit" }}>
        Not Functioning
      </EuiHealth>
    ),
  },
  {
    value: "Functioning But Requres Attention to Function Properly",
    inputDisplay: (
      <EuiHealth color="subdued" style={{ lineHeight: "inherit" }}>
        Functioning But Requres Attention to Function Properly
      </EuiHealth>
    ),
  },
];

export const innovStageOptions = [
  {
    value: "Idea",
    inputDisplay: (
      <EuiHealth color="warning" style={{ lineHeight: "inherit" }}>
        Idea
      </EuiHealth>
    ),
  },
  {
    value: "Concept Paper Stage",
    inputDisplay: (
      <EuiHealth color="warning" style={{ lineHeight: "inherit" }}>
        Concept Paper Stage
      </EuiHealth>
    ),
  },
  {
    value: "Schematic Drawing",
    inputDisplay: (
      <EuiHealth color="warning" style={{ lineHeight: "inherit" }}>
        Schematic Drawing
      </EuiHealth>
    ),
  },
  {
    value: "Developed Product",
    inputDisplay: (
      <EuiHealth color="warning" style={{ lineHeight: "inherit" }}>
        Developed Product
      </EuiHealth>
    ),
  },
];

export const provinceOptions = [
  {
    value: "Copperbelt",
    inputDisplay: (
      <EuiHealth color="subdued" style={{ lineHeight: "inherit" }}>
        Copperbelt
      </EuiHealth>
    ),
  },
  {
    value: "Northwestern",
    inputDisplay: (
      <EuiHealth color="warning" style={{ lineHeight: "inherit" }}>
        Northwestern
      </EuiHealth>
    ),
  },
  {
    value: "Luapula",
    inputDisplay: (
      <EuiHealth color="danger" style={{ lineHeight: "inherit" }}>
        Luapula
      </EuiHealth>
    ),
  },
  {
    value: "Lusaka",
    inputDisplay: (
      <EuiHealth color="danger" style={{ lineHeight: "inherit" }}>
        Lusaka
      </EuiHealth>
    ),
  },
  {
    value: "Western",
    inputDisplay: (
      <EuiHealth color="danger" style={{ lineHeight: "inherit" }}>
        Western
      </EuiHealth>
    ),
  },
  {
    value: "Southern",
    inputDisplay: (
      <EuiHealth color="danger" style={{ lineHeight: "inherit" }}>
        Southern
      </EuiHealth>
    ),
  },
];

export const sdgOptions = [
  {
    label: "SDG 1. No Poverty",
  },
  {
    label: "SDG 2. Zero Hunger",
  },
  {
    label: "SDG 3. Good Health and Well-Being",
  },
  {
    label: "SDG 4. Quality Education",
  },
  {
    label: "SDG 5. Gender Equality",
  },
  {
    label: "SDG 6. Clean Water and Sanitation",
  },
  {
    label: "SDG 7. Affordable and Clean Energy",
  },
  {
    label: "SDG 8. Decent Work and Economic Growth",
  },
  {
    label: "SDG 9. Industry, Innovation, and Infrastructure",
  },
  {
    label: "SDG 10. Reduced Inequalities",
  },
  {
    label: "SDG 11. Sustainable Cities and Communities",
  },
  {
    label: "SDG 12. Responsible Consumption and Production",
  },
  {
    label: "SDG 13. Climate Action",
  },
  {
    label: "SDG 14. Life Below Water",
  },
  {
    label: "SDG 15. Life on Land",
  },
  {
    label: "SDG 16. Peace, Justice, and Strong Institutions",
  },
];
